import React from 'react';
import { MainWrapper } from '../main-wrapper';
import { IAPIStudioInfo } from '../../../model/api-modules';
import { IComponentProps } from '../../../model/studio';
import { AuditHubContentComponent } from './audit-hub-content';
import getFormatMessage from '../../../locales/get-format-message';
import './index.scss';
import { PermissionCheck } from '../../component/permission-check';

export const AuditHubRouter = () => {
  const renderCustomTitle = (studioInfo: IAPIStudioInfo | null) => {
    return studioInfo?.studio.Name;
  };

  const renderComponent = (props: IComponentProps) => {
    return (
      <PermissionCheck contentType="page" anyPermission={true}>
        <AuditHubContentComponent {...props} />
      </PermissionCheck>
    );
  };

  return (
    <MainWrapper
      className="audit-hub-page"
      title={getFormatMessage('per_audit')}
      renderComponent={renderComponent}
      renderCustomTitle={renderCustomTitle}
    />
  );
};
